import { ChevronRightIcon } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const TopicLandingCardSkeleton = () => {
  return (
    <li className="relative flex justify-between gap-x-6 px-4 py-5 sm:px-6">
      <div className="flex min-w-0 gap-x-4">
        <div className="min-w-0 flex-auto">
          <Skeleton className="h-6 w-32" />

          <div className="mt-1 space-y-1">
            <Skeleton className="h-5 w-full max-w-md" />
            <Skeleton className="h-5 w-3/4 max-w-sm" />
          </div>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-x-4">
        <div className="hidden sm:flex sm:flex-col sm:items-end">
          <Skeleton className="h-5 w-20" />
        </div>

        <ChevronRightIcon aria-hidden="true" className="size-5 flex-none text-transparent" />
      </div>
    </li>
  )
}

export const TopicLandingPageSkeleton = () => {
  return (
    <Card className="overflow-hidden p-0">
      <ul role="list" className="divide-y divide-border">
        {Array.from({ length: 4 }).map((_, index) => (
          <TopicLandingCardSkeleton key={index} />
        ))}
      </ul>
    </Card>
  )
}
